import React, { Fragment } from 'react';
import get from 'lodash/get';
import dateTimeFormat from 'legacy-src/utility/DateTime';
import { useTable } from 'chameleon/ui-stack/ui/base/table';
import CustomCell from 'chameleon/ui-stack/ui/assessments/CustomCell';
import Row from 'chameleon/ui-stack/ui/base/table/Row';

/**
 * Draws progress popover content
 * */
const ProgressPopoverContent = (props) => {
  const {
    header = 'Header',
    assignments = [],
    getSingleAssignmentAction,
  } = props;

  const renderRow = (row) => {
    const { original: assignment } = row || {};

    if (!assignment) {
      return null;
    }

    const learnosityActivityId = get(assignment, 'learnosityActivityId', '');
    const isSPPSandbox = (learnosityActivityId || '').startsWith('SPP_SANDBOX');
    const assignmentCreatedAt = get(assignment, 'assignmentCreatedAt', 0);
    const assignedDayMonth = isSPPSandbox
      ? 'n/a'
      : dateTimeFormat(assignmentCreatedAt, 'dateShortTwoDigitMonth');

    const cells = [
      CustomCell(
        `${assignment.id}-${1}`,
        get(assignment, 'name', ''),
        `!font-medium xm:pr-5 sm:pr-10 md:pr-20 desktop:pr-20`,
      ),
      CustomCell(
        `${assignment.id}-${2}`,
        assignedDayMonth,
        `xm:pr-5 sm:pr-10 md:pr-20 desktop:pr-20`,
      ),
      CustomCell(
        `${assignment.id}-${3}`,
        <div className="flex">{getSingleAssignmentAction(assignment)}</div>,
        `student-view-all-action-column`,
      ),
    ];

    return (
      <Row
        a11yIgnoreEvents
        row={row}
        className=""
        key={`${assignment.id}-${assignment.id}`}
        aria-label={assignment.title}
        isDisabled
      >
        <TableColumns cells={cells} />
      </Row>
    );
  };

  const getHeaders = () => [
    {
      Header: header,
      className: 'pl-8 pb-6',
      id: 'title',
    },
    {
      Header: 'Assigned On',
      className: 'pb-6',
      id: 'assigned_on',
    },
    {
      Header: '',
      id: 'action',
      className: 'pb-6',
    },
  ];

  const headers = getHeaders();

  const { Table, TableBody, TableColumns, TableHeader, tableItems } = useTable({
    data: assignments || [],
    headers,
  });

  return (
    <Fragment>
      <Table
        className="mt-5 sm:min-w-min md:min-w-max desktop:min-w-max"
        ariaLabel={`${header} assignments`}
      >
        <TableHeader rowClassName="border-bottom" />
        <TableBody>
          {Boolean((tableItems || []).length) &&
            tableItems.map((item) => renderRow(item))}
        </TableBody>
      </Table>
    </Fragment>
  );
};

export default ProgressPopoverContent;
